var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReviewFlagActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.016 10.2753L13.9993 9.25866C13.7577 9.05033 13.616 8.74199 13.6077 8.40033C13.591 8.02533 13.741 7.65033 14.016 7.37533L15.016 6.37533C15.8827 5.50866 16.2077 4.67533 15.9327 4.01699C15.666 3.36699 14.841 3.00866 13.6243 3.00866H4.91602V2.29199C4.91602 1.95033 4.63268 1.66699 4.29102 1.66699C3.94935 1.66699 3.66602 1.95033 3.66602 2.29199V17.7087C3.66602 18.0503 3.94935 18.3337 4.29102 18.3337C4.63268 18.3337 4.91602 18.0503 4.91602 17.7087V13.642H13.6243C14.8243 13.642 15.6327 13.2753 15.9077 12.617C16.1827 11.9587 15.866 11.1337 15.016 10.2753Z",
    fill: "#C28931"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewFlagActive);
export default __webpack_public_path__ + "static/media/review_flag_active.10fd6db8d51a5bf06664ac8b0392e0c3.svg";
export { ForwardRef as ReactComponent };